import { ReactNode } from 'react';

interface MemberOperatorTaskProps {
    children: ReactNode;
}

export default function MemberOperatorTask({ children }: MemberOperatorTaskProps) {
    return <div>{children}</div>;
}
